import { render, staticRenderFns } from "./TedarikciSiparisleri.vue?vue&type=template&id=5ef39d5b"
import script from "./TedarikciSiparisleri.vue?vue&type=script&lang=js"
export * from "./TedarikciSiparisleri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports